export default "__VITE_ASSET__BLNTFGVP__"